import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

type Props = {
  /** Current 6-digit value. */
  value: string;
  /** Called with the digits-only, max-6 sanitised value. */
  onChange: (value: string) => void;
  id?: string;
  className?: string;
} & Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'id' | 'type' | 'maxLength' | 'pattern' | 'inputMode'
>;

/**
 * Controlled 6-digit verification-code input shared across the auth magic-link
 * surfaces. Filters non-digits and caps at 6 characters on input, so the parent
 * always holds a clean value.
 */
export function OtpCodeInput({ value, onChange, id = 'code', className, ...rest }: Props) {
  return (
    <Input
      id={id}
      type="text"
      inputMode="numeric"
      pattern="[0-9]{6}"
      maxLength={6}
      placeholder="000000"
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
      autoComplete="one-time-code"
      className={cn('h-12 text-center text-lg font-mono tabular-nums tracking-[0.4em]', className)}
      {...rest}
    />
  );
}
